import type { CSSProperties } from 'react'

import styled from 'styled-components'
import { theme } from 'styles/theme/hav-theme'

type FlexProps = {
  direction?: 'row' | 'column'
  alignItems?: CSSProperties['alignItems']
  justifyContent?: CSSProperties['justifyContent']
  fullWidth?: boolean
  gap?: keyof typeof theme.spacing
  ionGap?: keyof typeof theme.spacing.ion
}

export const Flex = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    !['direction', 'alignItems', 'justifyContent', 'fullWidth', 'gap', 'ionGap'].includes(prop),
})<FlexProps>`
  display: flex;
  flex-direction: ${({ direction = 'row' }) => direction};
  align-items: ${({ alignItems = 'baseline' }) => alignItems};
  justify-content: ${({ justifyContent = 'normal' }) => justifyContent};
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  gap: ${({ gap }) => (gap ? theme.spacing[gap] : 0)};
  ${({ ionGap }) => ionGap && `gap: ${theme.spacing.ion[ionGap]}`}
`
